import { $_app_server } from '@/_helpers'

export const agreementService = {
    loadMyAgreement,
    downloadAgreement,
    saveLoadAgreement,
    downloadSignedAgreement,
    checkAgreement,
    getAvailableYears,
    getNotViewedMyAgreement
}

let func = (response) => response.data

function loadMyAgreement(month, year) {
  return $_app_server.get(`agreement/getMyAgreement?month=${month}&year=${year}`).then(func)
}

function downloadAgreement(agreementId) {
  return $_app_server.get(`agreement/downloadAgreement?agreementId=${agreementId}`, {
    responseType: 'blob'
  })
}

function saveLoadAgreement(obj) {
  return $_app_server.post('agreement/saveSignedAgreements', obj).then(func)
}

function getNotViewedMyAgreement() {
  return $_app_server.get(`agreement/getNotViewedMyAgreement`).then(func)
}

function downloadSignedAgreement(agreementId) {
  return $_app_server.get(`agreement/downloadSignedAgreement?agreementId=${agreementId}`, {
    responseType: 'blob'
  })
}

function checkAgreement(agreementId) {
  return $_app_server.post(`agreement/checkAgreement?agreementId=${agreementId}`).then(func)
}

function getAvailableYears() {
  return $_app_server.get(`agreement/availableYears`).then(func)
}
